import { Box, Group, Icon, OptimizeImage, Stack, Text } from '@inflearn/ds-react-next';
import { faPause, faPlay } from '@inflearn/pro-solid-svg-icons';
import { useEffect, useRef, useState } from 'react';
import { BGM_AUDIO, CDN_BASE_PATH } from './itemData';

export const BgmPlayer = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    // 오디오 요소 생성
    const audio = new Audio(BGM_AUDIO.BGM_1);
    audio.loop = true;
    audio.volume = 0.5;
    audioRef.current = audio;

    return () => {
      // 컴포넌트 언마운트 시 정리
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const togglePlay = () => {
    if (!audioRef.current) {
      return;
    }

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play().catch((error) => {
        console.error('BGM 재생 실패:', error);
      });
      setIsPlaying(true);
    }
  };

  return (
    <Box
      role="button"
      pos="absolute"
      top={180}
      right={80}
      onClick={togglePlay}
      w={138}
      h={46}
      css={{
        zIndex: 1000,
        cursor: 'pointer',
      }}
    >
      <Box
        pos="absolute"
        top={0}
        left={0}
        w={'100%'}
        h={'100%'}
        css={{
          borderRadius: '50px',
          background: 'linear-gradient(135deg, #FFF3CA 0%, #B7DAC1 100%)',
          zIndex: -1,
        }}
      ></Box>
      <Group
        gap={6}
        m={3}
        pl={14}
        py={5}
        styles={{
          root: {
            backgroundColor: 'white',
            borderRadius: '50px',
          },
        }}
      >
        <OptimizeImage
          src={`${process.env.NEXT_PUBLIC_CDN_INTEGRATED_HOST}/image/apng/musical-notes.png`}
          alt="musical-notes"
          w={22 * 2}
          width={22}
          height={22}
        />
        <Stack align="flex-start">
          <Text fz={10} fw={600} c="gray.7">
            너의 모든 캐롤
          </Text>
          <Text fz={10} fw={400} c="gray.6">
            인프런 성시경
          </Text>
        </Stack>
        <Stack pl={4}>
          <Icon icon={isPlaying ? faPause : faPlay} size="xs" color="gray.7" />
        </Stack>
      </Group>
      {!isPlaying && (
        <OptimizeImage
          src={`${CDN_BASE_PATH}/ch_img_highlight.png`}
          w={50 * 2}
          width={50}
          height={50}
          css={{
            position: 'absolute',
            top: -10,
            right: -10,
            pointerEvents: 'none',
          }}
        />
      )}
    </Box>
  );
};
